import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { useUserAuth } from "../context/UserAuthContext";

const API = process.env.REACT_APP_BACKEND_URL;
const LOGO = "https://customer-assets.emergentagent.com/job_261f6229-25c6-462a-bf7c-d1c15ef074eb/artifacts/rv1gzzra_logo%20v2%20xpro.png";

export default function UserLoginPage() {
  const navigate = useNavigate();
  const { login, user } = useUserAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Already logged in
  if (user) return <Navigate to="/inicio" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API}/api/auth/user-login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase(), password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.detail || "Error al iniciar sesión"); return; }
      login(data.user, data.access_token);
      navigate("/inicio", { replace: true });
    } catch {
      setError("Error de conexión. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 py-12">
      <img src={LOGO} alt="XPRO FITNESS" className="h-10 w-auto mb-10" />

      <div className="w-full max-w-sm" data-testid="login-form">
        <h1 className="text-2xl font-black mb-1">Accede a tu rutina</h1>
        <p className="text-white/45 text-sm mb-7">
          Entra con el email y la contraseña que creaste al activar tu cuenta.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-[10px] tracking-[0.2em] uppercase font-bold text-white/50 mb-1.5">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
              required
              data-testid="login-email"
              className="w-full bg-[#111] border border-white/12 text-white px-4 py-3 text-sm outline-none focus:border-[#F2C230] transition-colors"
            />
          </div>
          <div>
            <label className="block text-[10px] tracking-[0.2em] uppercase font-bold text-white/50 mb-1.5">Contraseña</label>
            <div className="relative">
              <input
                type={showPw ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Tu contraseña"
                required
                data-testid="login-password"
                className="w-full bg-[#111] border border-white/12 text-white px-4 py-3 pr-12 text-sm outline-none focus:border-[#F2C230] transition-colors"
              />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70">
                {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
          {error && <p className="text-red-400 text-xs" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading || !email || !password}
            data-testid="login-submit"
            className="w-full bg-[#F2C230] text-black font-black text-[11px] tracking-[0.25em] uppercase py-4 hover:bg-white transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            {loading ? "Entrando..." : "Iniciar sesión"}
          </button>
        </form>

        <p className="text-white/25 text-xs text-center mt-8">
          ¿No tienes cuenta? El equipo de XPRO te envía la invitación.
        </p>
      </div>
    </div>
  );
}
